import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './PromptLibrary.css';
import ModalView from '../components/PopUp';
import PlainButton, { UnileverButton } from '../components/ButtonComponents';
import PageHeader from '../components/PageHeader';
import { usePromptLibraryContext } from '../context/PromptLibraryContext';
import LoadingBox from '../components/LoadingBox';
import DeleteModal from '../components/DeletePopUp';
import { useNavigate } from 'react-router-dom';
import { VersionsPopUp } from '../components/VersionsPopUp';
import {
  SearchComponent,
  FilterComponent,
  CardComponent,
  PromptTypeButtonComponent
} from '../components/PromptCommonFunctions';
import CodeViewPopUp from '../components/CodeviewPopUp';

const PromptLibrary = () => {
  const navigate = useNavigate();

  const [isAllPrompt, setAllPromptStatus] = useState(true);
  const [showCopyPrompt, setCopyPrompt] = useState(false);

  const {
    allPromptData,
    myPromptData,
    error,
    isLoading,
    getPromptlibraryData,
    codeView,
    setCodeView,
    setCodeViewPromptId
  } = usePromptLibraryContext();
  type itemType = {
    author: string;
    currentVersion: string;
    description: string;
    title: string;
    totalVersions: number;
    tags: string[];
    is_new: boolean;
    promptID?: string;
    prompt_id?: string;
    is_prompt_type_private: boolean;
    versionDetail?: string;
    latest_version_id?: string;
    versions?: {}[];
  };
  const [quickTerms, setQuickTerms] = useState([]);
  const [selectedTerms, setSelectedTerms] = useState<string[]>([]);
  const [allPromptCardsData, setAllPromptCardData] = useState<itemType[]>([]);
  const [myPromptCardsData, setmyPromptCardData] = useState<itemType[]>([]);
  const [searchValue, setSearchValue] = useState<string>('');
  const selectedType = isAllPrompt ? allPromptData : myPromptData;
  const [selectedCard, setSelectedCard] = useState(0);
  const [deletepopUp, setDeletePopUp] = useState(false);

  const handleQuickTerms = (term: string) => {
    var temp = [...selectedTerms];
    const index = temp?.indexOf(term);

    if (index > -1) {
      temp.splice(index, 1);

      setSelectedTerms(temp);
    } else setSelectedTerms([...selectedTerms, term]);
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const is_prompt_type_private = queryParams.get('is_prompt_type_private');
  const [versionsPopUp, setVersionsPopUp] = useState(false);

  useEffect(() => {
    getPromptlibraryData();

    if (is_prompt_type_private === 'true') {
      setAllPromptStatus(false);
    }
  }, []);

  useEffect(() => {
    var temp: itemType[] = [];
    setQuickTerms(selectedType?.meta?.quick_terms);
    selectedType?.items?.map((item: itemType) => {
      temp.push({
        author: item?.author || 'Steve',
        currentVersion: item?.currentVersion || '99',
        description: item?.description || 'Desc',
        title: item?.title || 'Title',
        totalVersions: item?.totalVersions || 98,
        tags: item?.tags || [],
        is_new: item?.is_new || false,
        promptID: item?.prompt_id || '',
        is_prompt_type_private: item?.is_prompt_type_private || false,
        versionDetail: item?.latest_version_id || '',
        versions: item?.versions || []
      });

      isAllPrompt ? setAllPromptCardData(temp) : setmyPromptCardData(temp);
    });
  }, [isAllPrompt, selectedType]);

  useEffect(() => {
    setSelectedTerms([]);
    setSearchValue('');
  }, [isAllPrompt]);

  const handleFilter = () => {
    return FilterComponent({
      isAllPrompt,
      allPromptCardsData,
      myPromptCardsData,
      searchValue,
      selectedTerms
    });
  };

  // const [codeView, setCodeView] = useState(false);

  return isLoading ? (
    <LoadingBox />
  ) : (
    <div style={{ padding: 50, height: '100%' }}>
      <CodeViewPopUp
        open={codeView}
        handleClose={() => {
          setCodeView(false);
          setCodeViewPromptId('');
        }}
      />

      <DeleteModal
        open={deletepopUp}
        headerName={'Delete Prompt'}
        description1={'Are you sure you want to delete '}
        description2={`Category-Level Savings Identifier?`}
        handleClose={() => setDeletePopUp(false)}
        queryData={{
          promptID: handleFilter()?.[selectedCard]?.promptID,
          versionID: handleFilter()?.[selectedCard]?.versionDetail
        }}
        versionList={handleFilter()?.[selectedCard]?.versions}
      />

      <ModalView
        open={showCopyPrompt}
        handleClose={() => setCopyPrompt(false)}
        id={handleFilter()?.[selectedCard]?.promptID}
        totalVersions={handleFilter()?.[selectedCard]?.totalVersions}
        promptName={handleFilter()?.[selectedCard]?.title}
        setAllPromptStatus={() => setAllPromptStatus(false)}
      />

      <VersionsPopUp open={versionsPopUp} handleClose={() => setVersionsPopUp(false)} />

      {/* Header Section */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
        <PageHeader
          headerName="Prompt Library"
          description="Browse prompts across modalities, Functions and Business/Categories to help you get
            started.">
          {' '}
          <img
            style={{ width: '24px', height: '24px', marginRight: '5px', fontWeight: '600px' }}
            src={require('../assets/img/promptLibrary.png')}
          />
        </PageHeader>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          {/* <div
            className="d-flex justify-content-center align-items-center m-1"
            style={{ cursor: 'pointer', maxHeight: 43 }}
            onClick={() => {
              setCodeView(true);
              setCodeViewPromptId('');
            }}>
             <CopyIcon />
            <PlainButton>
              <i className="bi bi-code-slash" style={{ fontSize: 20 }}></i>
            </PlainButton>
          </div> */}
          <PromptTypeButtonComponent
            isAllPrompt={isAllPrompt}
            handleClick={() => setAllPromptStatus(!isAllPrompt)}
          />

          <SearchComponent
            searchValue={searchValue}
            handleSelection={(name, value) => setSearchValue(value)}
          />

          <UnileverButton
            buttonAction={() => {
              navigate('/addPrompt');
            }}>
            {' '}
            + Add Prompt
          </UnileverButton>
        </div>
      </div>

      {/* Quick Teerms Section */}
      <div className="d-flex align-items-center" style={{ gap: '10px', margin: '16px 0' }}>
        <div className="h-full h_400" style={{ color: 'var(--text_darkGrey)' }}>
          Business Category:
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
          {quickTerms?.map((term: string, index: number) => (
            <div
              key={term + index}
              className={`${
                (index === 0 && selectedTerms?.length === 0) || selectedTerms?.indexOf(term) > -1
                  ? 'blueButton'
                  : 'unSelectedButton'
              } , alignDataCenter QuickTermsButton`}
              onClick={() => (index !== 0 ? handleQuickTerms(term) : setSelectedTerms([]))}>
              {term}
            </div>
          ))}
        </div>
      </div>

      <CardComponent
        isPromptLibrary={true}
        handleFilter={() => handleFilter()}
        isAllPrompt={isAllPrompt}
        setCopyPrompt={setCopyPrompt}
        setSelectedCard={setSelectedCard}
        setDeletePopUp={setDeletePopUp}
        setVersionsPopUp={setVersionsPopUp}
      />
    </div>
  );
};

export default PromptLibrary;
